import { WithStyles, withStyles } from '@mui/styles';
import { FilterModel, SortModel } from '@tassat/common-definitions';
import { Location } from 'history';

import { AdminUsers } from './adminUsers';
import { muiStyles } from './adminUsersStyles';

export interface AdminUsersProps extends WithStyles<typeof muiStyles>{
    location: Location<{
        filterModel: { string: FilterModel };
        sortModel: Array<SortModel>;
    }>;
}

export default withStyles(muiStyles)(AdminUsers);